<template>
  <div class="modal-backdrop" @click="hidePrivacy">
    <div class="modal"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription" @click.stop>
      <header class="modal-header" id="modalTitle">
        Personvern
        <button
          type="button"
          class="btn-close"
          @click="hidePrivacy"
          aria-label="Lukk"
          title="Lukk"
        >
          x
        </button>
      </header>
      <section class="modal-body" id="modalDescription">
        <PrivacyPolicy />
      </section>
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from './PrivacyPolicy'
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions(['hidePrivacy'])
  },
  components: {
    PrivacyPolicy
  }
}
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }
  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px rgb(48, 48, 48);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 800px;
    color: rgb(20, 20, 20);
  }
  .modal-header,
  .modal-footer {
    padding: 10px 20px;
    display: flex;
    align-items: center;
  }

  .modal-header {
    font-size: 30px;
    border-bottom: 1px solid #eeeeee;
    color: #25ad8b;
    justify-content: space-between;
  }
  .modal-body {
    position: relative;
    padding: 10px 20px;
  }
  .btn-close {
    border: none;
    font-size: 20px;
    padding: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #25ad8b;
    background: transparent;
  }
</style>
